export const config = {
    // apiUrl: 'https://qa-dashboard.zencecrm.com',
    // apiUrl: 'https://dashboard.ercollecta.com',
    apiUrl: 'https://ndjs-zencecrm.easyrewardz.com',
    identifier: 'shivam.dewangan@easyrewardz.com',
    password: 'Shiv7689',
    decryptToken: 'bca0ea522ddc5bed047eba302de580b405a5f1be3d3aa5c3a891b2a6dda07c420c2a62a49f6ced9a8778029adc241ac674bd2cf61180eff9aaa3a20818efb65f2c5ec0b098483993746018fdb4f273b8cc861f64c7512e6777ba81360ea77973d542c3a04aa9c4c77be9d879276b42da5d013feabb48a568193d541ca3e49ae4',
};